import { MapContainer, Marker, Polyline, Popup, TileLayer } from "react-leaflet";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ensureLeafletMarkerIcons } from "./LeafletConfig";

export default function RouteMap({
  center,
  startPoint,
  points,
  onShowStartImage,
  onShowPointImage,
}) {
  ensureLeafletMarkerIcons();
  const navigate = useNavigate();

  const routePointsWithoutStart = points.filter(
    (point) => point.id !== startPoint.id
  );

  const polyline = useMemo(
    () => [
      [startPoint.lat, startPoint.lng],
      ...routePointsWithoutStart.map((point) => [point.lat, point.lng]),
    ],
    [startPoint, routePointsWithoutStart]
  );

  return (
    <div className="mapWrap">
      <MapContainer center={center} zoom={17} scrollWheelZoom={false}>
        <TileLayer
          attribution="&copy; OpenStreetMap"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <Polyline positions={polyline} />

        <Marker position={[startPoint.lat, startPoint.lng]}>
          <Popup>
            <strong>{startPoint.title}</strong>

            <div className="mutedSmall" style={{ marginTop: 6 }}>
              {startPoint.shortDescription}
            </div>

            <div className="mutedSmall" style={{ marginTop: 4 }}>
              {startPoint.lat.toFixed(6)}, {startPoint.lng.toFixed(6)}
            </div>

            <div className="row gap wrap" style={{ marginTop: 8 }}>
              <button
                type="button"
                className="btn btnSmall"
                style={{ borderRadius: "4px" }}
                onClick={onShowStartImage}
              >
                Pokaż zdjęcie
              </button>

              <button
                type="button"
                className="btn btnSmall"
                style={{ borderRadius: "4px" }}
                onClick={() => navigate(`/sciezka-czasu/${startPoint.slug}`)}
              >
                Przejdź do miejsca
              </button>
            </div>
          </Popup>
        </Marker>

        {routePointsWithoutStart.map((point) => (
          <Marker key={point.id} position={[point.lat, point.lng]}>
            <Popup>
              <strong>
                {point.order}. {point.title}
              </strong>

              <div className="mutedSmall" style={{ marginTop: 6 }}>
                {point.shortDescription}
              </div>

              <div className="mutedSmall" style={{ marginTop: 4 }}>
                {point.lat.toFixed(6)}, {point.lng.toFixed(6)}
              </div>

              <div className="row gap wrap" style={{ marginTop: 8 }}>
                <button
                  type="button"
                  className="btn btnSmall"
                  style={{ borderRadius: "4px" }}
                  onClick={() => onShowPointImage(point)}
                >
                  Pokaż zdjęcie
                </button>

                <button
                  type="button"
                  className="btn btnSmall"
                  style={{ borderRadius: "4px" }}
                  onClick={() => navigate(`/sciezka-czasu/${point.slug}`)}
                >
                  Przejdź do miejsca
                </button>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}